import React from "react";

const Icon = (props) => {
  const { icon, className, style } = props;
  return (
    <svg className={`icon ${className || ""}`} style={style} aria-hidden="true">
      <use xlinkHref={`#icon-${icon}`} />
    </svg>
  );
};

export default Icon;
